import React from "react";
import { useParams } from "react-router-dom";
import { Box, Heading, Text } from "@chakra-ui/react";
import DriverSimLite from "../RealTime/DriverSimLite";

export default function SimLitePage() {
    const { deliveryId } = useParams<{ deliveryId: string; }>();
    if (!deliveryId) return <Text>Missing delivery id.</Text>;

    return (
        <Box p={4}>
            <Heading size="md" mb={3}>DriverSimLite</Heading>
            <Text mb={3}>Trip: {deliveryId}</Text>
            <DriverSimLite tripId={deliveryId} />
        </Box>
    );
}
